module.exports = __webpack_public_path__ + "img/7.f8466d01.jpg";